"use client";
import { Icon } from "@iconify/react";
import Link from "next/link";

const GridMegaMenuMobile = ({ open, toggle, menu }) => {
  return (
    <div>
      <button
        onClick={toggle}
        className="flex justify-between items-center text-[14px] font-semibold text-user-text w-full py-2"
      >
        <p>{menu?.name}</p>
        <Icon
          icon="lucide:chevron-down"
          width="18"
          height="18"
          className={`transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        className={`bg-gray-100 px-3 rounded-lg overflow-hidden transition-all duration-300 ease-out
        ${open ? "max-h-96 py-2 opacity-100" : "max-h-0 py-0 opacity-0"}`}
      >
        <ul>
          {menu?.megamenu_items?.map((product) => (
            <li key={product.id}>
              <Link
                href={`${product?.url}`}
                className="block text-[14px] font-semibold py-2 text-user-text"
              >
                {product?.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GridMegaMenuMobile;
